(() => {
  const header = document.querySelector(".qed-header");
  if (!header) return;

  const menu = header.querySelector("[data-qed-mobile-menu]");
  const closeButton = header.querySelector("[data-qed-menu-close]");

  const setOpen = (open) => {
    if (!menu) return;
    menu.open = open;
    document.documentElement.classList.toggle("qed-menu-open", open);
  };

  closeButton?.addEventListener("click", () => setOpen(false));

  menu?.addEventListener("toggle", () => {
    document.documentElement.classList.toggle("qed-menu-open", menu.open);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && menu?.open) {
      setOpen(false);
      menu.querySelector("summary")?.focus();
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 989 && menu?.open) setOpen(false);
  });
})();
